// Прячет закреплённое меню при скролле вверх и показывает при скролле вниз.
// Работает только на узких экранах (< 640px) — там меню растянуто по низу; на
// широких оно всегда видно, а transform в CSS ограничен тем же медиазапросом.
export default function revealPinnedMenu(element) {
    const ALWAYS_HIDDEN_ZONE = 90; // px от верха: у самого верха меню держим скрытым
    const THRESHOLD = 10; // порог чувствительности, чтобы не дёргалось на мелких сдвигах

    let lastScroll = window.scrollY;

    const onScroll = () => {
        const current = window.scrollY;

        if (current < ALWAYS_HIDDEN_ZONE) {
            element.classList.add("is-hidden");
            lastScroll = current;
            return;
        }

        const delta = current - lastScroll;
        if (Math.abs(delta) < THRESHOLD) return;

        // Вниз (delta > 0) — показываем, вверх — прячем.
        element.classList.toggle("is-hidden", delta < 0);
        lastScroll = current;
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
}
